export enum CardNumberValidity {
  Valid,
  InvalidNumber,
  CardBrandIneligible,
  BinIneligible,
}

export enum CardExpiryValidity {
  Valid,
  Invalid,
  Expired,
  ExpiringSoon,
  ExpireInLimitMonths,
}
